export default __webpack_public_path__ + "static/media/birthday_bg.c712e496.jpg";